// @ts-expect-error legacy
import Donut from "@/pages/rum/v2/details/graphs/DonutGraph.jsx";
// @ts-expect-error legacy
import PerformanceDistributionGraph from "@/pages/rum/v2/details/graphs/PerformanceDistributionGraph.jsx";
import {RUMGraphHeader} from "@/pages/rum/v2/details/graphs/RumGraphHeader.tsx";
import {ReportSpec} from "@/pages/rum/v2/details/ReportDefType.ts";

interface DistributionGraphSectionProps {
  checkName: string;
  hist: JSON;
  donut: JSON;
  reportSpec: ReportSpec;
}

export const SectionDistributionGraph = ({checkName, hist, donut, reportSpec}: DistributionGraphSectionProps) => {
  const distributionClass = donut ? "col-lg-9" : "col";
  if (!reportSpec.hist && !reportSpec.donut) {
    return null;
  }

  return (
    <>
      <hr className="my-4" />
      <div className="row">
        <RUMGraphHeader title={`${reportSpec.name} distribution`} supportLink={reportSpec.doc} />
        {reportSpec.hist && (
          <div className={distributionClass}>
            <PerformanceDistributionGraph
              checkName={checkName}
              data={hist}
              feature={reportSpec.hist.feature}
              ranges={reportSpec.hist.ranges}
              noDataMessage={reportSpec.noDataMessage}
            />
          </div>
        )}
        {reportSpec.donut && (
          <div className="col-lg-3">
            <div className="border rounded p-4 donut-outer-container">
              <Donut
                checkName={checkName}
                data={donut}
                header={reportSpec.donut.header}
                featureColors={reportSpec.donut.featureColors}
                title={reportSpec.name}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
